// extracted by mini-css-extract-plugin
export var container = "exploreMangomint-module--container--4bbdc";
export var heading = "exploreMangomint-module--heading--ed290";
export var wrapper = "exploreMangomint-module--wrapper--7041a";